import PropTypes from 'prop-types'

import CardWrapper from 'components/dashboard/CardWrapper'
import useAgent from 'hooks/use-agent'
import useAuth from 'hooks/use-auth'

import { RecentExperiments } from './RecentExperimentsCard'

export default function RecentScenariosCard({ scenarios, scenariosLoading }) {
  const { currentTeamId } = useAuth()

  const { data: publishedScenarios, isLoading } = useAgent(
    `/scenarios?pageSize=11&teamId=${currentTeamId}`,
    [],
    {
      shouldCache: true
    }
  )

  const allScenarios = scenarios
    .map((scenario) => {
      scenario.state = 'RUNNING'
      return scenario
    })
    .concat(publishedScenarios)
    .slice(0, 10)

  return (
    <CardWrapper
      hideFilter={true}
      renderCardContent={() => (
        <RecentExperiments
          isScenario
          allAttacks={allScenarios}
          attacksLoading={scenariosLoading || isLoading}
          displayViewAll={scenarios.concat(publishedScenarios).length > 10}
        />
      )}
      title="Recent Scenarios"
    />
  )
}

RecentScenariosCard.propTypes = {
  scenarios: PropTypes.array,
  scenariosLoading: PropTypes.bool
}
